import { Image } from 'expo-image';
import { Stack, useRouter } from 'expo-router';
import Head from 'expo-router/head';
import { Text, YStack } from 'tamagui';

import { PSHeaderBackButton } from '@/components/PSHeaderButtons';
import PSButton from '@/components/ui/PSButton';

// Matches the source's own 677×369 ratio so the cat is never stretched.
const ART_WIDTH = 280;
const ART_RATIO = 677 / 369;

/**
 * +not-found — expo-router's catch-all for any URL that matches no route.
 *
 * Rendered as a bare `flex={1}` centered stack, NOT inside PageScrollView:
 * that frame's ScrollView sizes its content container to its children, so a
 * `flex={1}` child inside it never gets a height to center within (the art
 * lands pinned under the header instead of mid-screen). The confirm screen's
 * `FullScreenMessage` uses the same bare-root trick for the same reason.
 *
 * Back stays in the header (in case there's somewhere real to return to) and
 * "Go Home" is the explicit way out for a cold deep link with no history to
 * back into.
 */
export default function NotFound() {
  const router = useRouter();

  return (
    <YStack
      flex={1}
      items="center"
      justify="center"
      gap="$space.xl"
      bg="$color.background"
    >
      <Head>
        <title>Page not found · Putting Scene</title>
      </Head>
      <Stack.Screen
        options={{
          headerTransparent: true,
          headerTitle: () => <></>,
          headerLeft: () => <PSHeaderBackButton />,
          unstable_headerLeftItems: () => [
            {
              type: 'custom',
              element: <PSHeaderBackButton />,
              hidesSharedBackground: true,
            },
          ],
        }}
      />

      <Image
        source={require('@/assets/images/not-found-cat.png')}
        style={{
          width: ART_WIDTH,
          height: ART_WIDTH / ART_RATIO,
          alignSelf: 'center',
        }}
        contentFit="contain"
        transition={200}
      />
      <Text
        fontFamily="$body"
        fontSize="$base"
        color="$textDark"
        textAlign="center"
      >
        Nothing found here
      </Text>
      <PSButton
        title="Go Home"
        variant="primary"
        onPress={() => router.replace('/')}
      />
    </YStack>
  );
}
